// Thin factory that spawns the Nowline LSP Web Worker. Kept separate
// from `client.ts` so tests can swap in a fake transport without dragging in the real
// `Worker` constructor.
//
// `new URL('./worker-entry.ts', import.meta.url)` is Vite's canonical
// pattern for module workers: at build time Vite rewrites the URL to a
// bundled worker chunk while preserving `type: 'module'` so the LSP's
// ESM dependencies (`langium`, `vscode-languageserver/browser.js`) load
// natively in the worker scope.

export function spawnLspWorker(): Worker {
    return new Worker(new URL('./worker-entry.ts', import.meta.url), {
        type: 'module',
        name: 'nowline-lsp',
    });
}
